export default "__VITE_ASSET__Ql$t1PnP__"